module.exports = __webpack_public_path__ + "img/105.a82d612.png";